{
  "burumoments_beach_01": {
    "rarity": 1
  },
  "burumoments_beach_02": {
    "rarity": 1
  },
  "burumoments_beach_03": {
    "rarity": 1
  },
  "burumoments_beach_04": {
    "rarity": 2
  },
  "burumoments_beach_05": {
    "rarity": 2
  },
  "burumoments_beach_06": {
    "rarity": 3
  },
  "burumoments_beach_07": {
    "rarity": 3
  },
  "burumoments_beach_08": {
    "rarity": 4
  },
  "burumoments_beach_09": {
    "rarity": 5
  },
  "burumoments_gym_01": {
    "rarity": 1
  },
  "burumoments_gym_02": {
    "rarity": 1
  },
  "burumoments_gym_03": {
    "rarity": 1
  },
  "burumoments_gym_04": {
    "rarity": 2
  },
  "burumoments_gym_05": {
    "rarity": 2
  },
  "burumoments_gym_06": {
    "rarity": 3
  },
  "burumoments_gym_07": {
    "rarity": 3
  },
  "burumoments_gym_08": {
    "rarity": 4
  },
  "burumoments_gym_09": {
    "rarity": 5
  },
  "burumoments_shopping_01": {
    "rarity": 1
  },
  "burumoments_shopping_02": {
    "rarity": 1
  },
  "burumoments_shopping_03": {
    "rarity": 1
  },
  "burumoments_shopping_04": {
    "rarity": 2
  },
  "burumoments_shopping_05": {
    "rarity": 2
  },
  "burumoments_shopping_06": {
    "rarity": 3
  },
  "burumoments_shopping_07": {
    "rarity": 3
  },
  "burumoments_shopping_08": {
    "rarity": 4
  },
  "burumoments_shopping_09": {
    "rarity": 5
  },
  "burumoments_pool_01": {
    "rarity": 1
  },
  "burumoments_pool_02": {
    "rarity": 1
  },
  "burumoments_pool_03": {
    "rarity": 1
  },
  "burumoments_pool_04": {
    "rarity": 2
  },
  "burumoments_pool_05": {
    "rarity": 2
  },
  "burumoments_pool_06": {
    "rarity": 3
  },
  "burumoments_pool_07": {
    "rarity": 3
  },
  "burumoments_pool_08": {
    "rarity": 4
  },
  "burumoments_pool_09": {
    "rarity": 5
  },
  "burumoments_cafe_01": {
    "rarity": 1
  },
  "burumoments_cafe_02": {
    "rarity": 1
  },
  "burumoments_cafe_03": {
    "rarity": 1
  },
  "burumoments_cafe_04": {
    "rarity": 2
  },
  "burumoments_cafe_05": {
    "rarity": 2
  },
  "burumoments_cafe_06": {
    "rarity": 3
  },
  "burumoments_cafe_07": {
    "rarity": 3
  },
  "burumoments_cafe_08": {
    "rarity": 4
  },
  "burumoments_cafe_09": {
    "rarity": 5
  },
  "burumoments_onsen_01": {
    "rarity": 1
  },
  "burumoments_onsen_02": {
    "rarity": 1
  },
  "burumoments_onsen_03": {
    "rarity": 1
  },
  "burumoments_onsen_04": {
    "rarity": 2
  },
  "burumoments_onsen_05": {
    "rarity": 2
  },
  "burumoments_onsen_06": {
    "rarity": 3
  },
  "burumoments_onsen_07": {
    "rarity": 3
  },
  "burumoments_onsen_08": {
    "rarity": 4
  },
  "burumoments_onsen_09": {
    "rarity": 5
  },
  "burumoments_camping_01": {
    "rarity": 1
  },
  "burumoments_camping_02": {
    "rarity": 1
  },
  "burumoments_camping_03": {
    "rarity": 1
  },
  "burumoments_camping_04": {
    "rarity": 2
  },
  "burumoments_camping_05": {
    "rarity": 2
  },
  "burumoments_camping_06": {
    "rarity": 3
  },
  "burumoments_camping_07": {
    "rarity": 3
  },
  "burumoments_camping_08": {
    "rarity": 4
  },
  "burumoments_camping_09": {
    "rarity": 5
  },
  "burumoments_playground_01": {
    "rarity": 1
  },
  "burumoments_playground_02": {
    "rarity": 1
  },
  "burumoments_playground_03": {
    "rarity": 1
  },
  "burumoments_playground_04": {
    "rarity": 2
  },
  "burumoments_playground_05": {
    "rarity": 2
  },
  "burumoments_playground_06": {
    "rarity": 3
  },
  "burumoments_playground_07": {
    "rarity": 3
  },
  "burumoments_playground_08": {
    "rarity": 4
  },
  "burumoments_playground_09": {
    "rarity": 5
  },
  "burumoments_karaoke_01": {
    "rarity": 1
  },
  "burumoments_karaoke_02": {
    "rarity": 1
  },
  "burumoments_karaoke_03": {
    "rarity": 1
  },
  "burumoments_karaoke_04": {
    "rarity": 2
  },
  "burumoments_karaoke_05": {
    "rarity": 2
  },
  "burumoments_karaoke_06": {
    "rarity": 3
  },
  "burumoments_karaoke_07": {
    "rarity": 3
  },
  "burumoments_karaoke_08": {
    "rarity": 4
  },
  "burumoments_karaoke_09": {
    "rarity": 5
  }
}
